import csv from "@images/csv.png";
import pdf from "@images/pdf.png";
import xls from "@images/xls.png";
import xlsx from "@images/xlsx.png";

export const statusData = [
  { name: "Active", status: "Active" },
  { name: "Inactive", status: "Inactive" },
];

export const equipmentStatus = [
  { key: "active", name: "Active" },
  { key: "inactive", name: "Inactive" },
  { key: "trial", name: "Trial" },
  { key: "disposed", name: "Disposed" },
  { key: "recalled", name: "Recalled" },
  { key: "being-serviced", name: "Being Serviced" },
];

export const medicationStatus = [
  { key: "active", name: "Active" },
  { key: "inactive", name: "Inactive" },
  { key: "trial", name: "Trial" },
  { key: "disposed", name: "Disposed" },
  { key: "replaced", name: "Replaced" },
  { key: "used", name: "Used" },
];

export const ACTIVE_STATUS = "active";

export const getNonActiveStatuses = (medication) =>
  (medication ? medicationStatus : equipmentStatus)
    .filter(({ key }) => key !== ACTIVE_STATUS)
    .map(({ key }) => key);

export const getEquipmentStatusFilter = (isInActive, medication) =>
  isInActive ? getNonActiveStatuses(medication) : [ACTIVE_STATUS];

export const getStatusLabel = (status) => {
  if (!status) return "";
  const key = String(status).toLowerCase();
  const match = [...equipmentStatus, ...medicationStatus].find(
    (item) => item.key === key,
  );
  return match?.name || status;
};

export const minimumValueData = [
  { name: "0", status: 0 },
  { name: "1", status: 1 },
];

export const maximumValueData = [
  { name: "5", status: 5 },
  { name: "10", status: 10 },
];

export const pdfFormatType = [
  { id: 1, label: "PDF-Landscape" },
  { id: 2, label: "PDF-Portrait" },
];

export const formTypeData = [
  { name: "Input", key: "input" },
  { name: "Select", key: "select" },
  { name: "Radio", key: "radio" },
  { name: "Checkbox", key: "checkbox" },
  { name: "Date", key: "date" },
  { name: "Time", key: "time" },
  { name: "File", key: "file" },
  { name: "Textarea", key: "textarea" },
  { name: "Multiple Choice Grid", key: "multiple_choice_grid" },
  { name: "Linear", key: "linear" },
  { name: "Scale", key: "scale" },
  { name: "Information", key: "information" },
];

export const privacyLevelData = [
  { id: true, name: "Shared" },
  { id: false, name: "Private" },
];

export const DuplicateCurrSelectOptions = [
  {
    id: 1,
    name: "Section",
    value: "section",
  },
  {
    id: 2,
    name: "Unit",
    value: "unit",
  },
  {
    id: 3,
    name: "Lesson",
    value: "lesson",
  },
  {
    id: 4,
    name: "Component",
    value: "component",
  },
  {
    id: 5,
    name: "Paragraph",
    value: "paragraph",
  },
];

export const TOKEN_EXPIRE_TIME = 180;

export const neffyUseQuestions = [
  {
    name: "survey_1",
    label: "Who responded to the event to administer or help administer Neffy?",
    options: ["School Nurse", 'Health Assistant', 'Athletic Trainer', "Teacher", "Other Faculty/Staff"],
  },
  {
    name: "survey_2",
    label: "Where did the event occur?",
    options: ["Cafeteria", "Classroom", "Health Office", "Outside", "Off school grounds (bus, field trip, etc)", "Other"],
  },
  {
    name: "survey_3",
    label: "Did the student return to class?",
    options: ["Yes", "No"],
  },
  {
    name: "survey_4",
    label: "Are you open to being contacted if a member of School Health or ARS Pharma wishes to reach out to you?",
    options: ["Yes", "No"],
  },
];



export const neffyUseShippingFields = [
  ["first_name", "First Name"],
  ["last_name", "Last Name"],
  ["email", "Email"],
  ["phone", "Phone"],
  ["location_name", "School / Location Name"],
  ["location_address", "Address"],
  ["location_city", "City"],
  ["location_state", "State"],
  ["location_zip", "ZIP Code"],
];

// Report
export const reportData = [
  { name: "Training", type: "course" },
  { name: "Credential", type: "credential" },
  { name: "Order", type: "order" },
  { name: "Inventory", type: "inventory" },
  { name: "Equipment", type: "equipment" },
  { name: "Medication", type: "medication" },
];

export const reportStaticData = [
  { name: "Location", type: "location" },
  { name: "People", type: "user" },
];

export const reportStaticSubData = {
  Training: [{ name: "Attendee", type: "attendee" }],
  Equipment: [
    { name: "Accessory", type: "accessory" },
    { name: "Activity", type: "activity" },
    { name: "Document", type: "document" },
    { name: "Inspection", type: "inspection" },
  ],
  Medication: [
    { name: "Activity", type: "activity" },
    { name: "Document", type: "document" },
    { name: "Inspection", type: "inspection" },
  ],
  Location: [
    { name: "Activity", type: "activity" },
    { name: "Document", type: "document" },
  ],
};

export const reportSortData = [
  { key: "name", name: "Name" },
  { key: "created_at", name: "Created At" },
  { key: "type", name: "Report Type" },
];

export const reportFilterReports = [
  { name: "Accessory", type: "accessory" },
  { name: "Activity", type: "activity" },
  { name: "Attendee", type: "attendee" },
  { name: "Document", type: "document" },
  { name: "Inspection", type: "inspection" },
];

export const exportFileTypes = [
  { name: "CSV", format: "csv", icon: csv },
  { name: "PDF", format: "pdf", icon: pdf },
  { name: "XLS", format: "xls", icon: xls },
  { name: "XLSX", format: "xlsx", icon: xlsx },
];
